import styled from "styled-components";
import { devices } from "../../../../globalStyle";

export const Container = styled.div`
  width: 84.7vw;
  max-height: 56.5vh;
  margin-top: 2.2vh;
  margin-left: 1vw;
  padding-right: 0.1vw;
  padding-bottom: 0.1vh;
  background-color: #f5f5f5;
  overflow-x: auto;
  font-family: 'Inter', sans-serif;
  @media ${devices.largeDesktop} {
    width: 87.7vw;
  }
  .short {
    width: 83.7vw;
      @media ${devices.largeDesktop} {
    width: 87.6vw;
  }
  }

  
  ::-webkit-scrollbar {
    width: 8px; 
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0; 
    border-radius: 10px; 
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff; 
    border-radius: 10px; 
    border: 2px solid #c0c0c0; 
  }
`

export const Table = styled.table`
  text-align: start;
  border-collapse: collapse;
  width: 100%;
  padding-right: 4vw;

  tr:nth-child(2) td:first-child {
    border-top-left-radius: 0.7vw;
  }

  tr:nth-child(2) td:last-child {
    border-top-right-radius: 0.7vw;
  }

  tr:last-child td:first-child {
    border-bottom-left-radius: 0.7vw;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: 0.7vw;
  }
`

export const HeaderRow = styled.tr`
  position: sticky;
  top: 0;
  height: 5vh;
  background-color:#f5f5f5;
  z-index:1;
`

export const HeaderCell = styled.th`
  color: #696969;
  text-align: start;
  border: 0;
  font-size: 14px;
  padding-left: 1vw;
`

export const MachineRow = styled.tr`
  height: 10vh;
  background-color:#fff;
`

export const MachineCell = styled.td`
  width: 15vw;
  text-align: start;
  font-size: 14px;
  padding-left: 1vw;
  border-bottom: solid 1px #ebebeb;
  word-wrap: break-word;
  overflow-wrap: break-word;
`

export const ContainerButtonsCell = styled.div`
  display: flex;
  align-items: center;
  gap: 1.8rem;
  justify-content: end;
  padding-right: 1vw;
  img{
    width: 1.2rem;
    cursor: pointer;
  }
`